var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlcohol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Alcohol",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2255",
    "data-name": "Rectangle 2255",
    width: 52.49,
    height: 74.119,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.316
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#8e2828",
    opacity: 0.402
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795",
    transform: "translate(31.924 15.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14829",
    "data-name": "Path 14829",
    d: "M7.01,9.4c0,1.352-.032,2.628.006,3.9A11.282,11.282,0,0,1,3.3,22.262a10.077,10.077,0,0,0-3.277,7.52Q-.024,50.692.005,71.6a2.348,2.348,0,0,0,1.672,2.381,4.55,4.55,0,0,0,1.239.128q8.434.012,16.868,0c2.063,0,2.944-.9,2.944-2.993q0-20.178.01-40.357a11.4,11.4,0,0,0-3.8-8.928,9.849,9.849,0,0,1-3.071-5.275,17.667,17.667,0,0,1-.333-3.035c-.055-1.361-.014-2.726-.014-4.124Zm34.441,48.8c.208-.033.322-.05.436-.07,6.774-1.169,11.322-6.946,10.511-13.668-.491-4.073-1.338-8.1-2.05-12.15a1.814,1.814,0,0,0-1.956-1.525q-8.226-.009-16.451,0a1.736,1.736,0,0,0-1.963,1.646c-.311,1.689-.611,3.38-.887,5.075-.424,2.61-1,5.212-1.2,7.84a11.9,11.9,0,0,0,8.742,12.331c.688.194,1.4.31,2.111.465a1.765,1.765,0,0,1,.045.277q0,6.03,0,12.059c0,.673-.349.995-1.017,1.076-1.613.2-3.222.426-4.832.652-.823.115-1.183.449-1.147,1.03s.434.866,1.273.87c1.65.007,3.3,0,4.949,0q4.531,0,9.062,0c.872,0,1.3-.3,1.318-.9.021-.569-.355-.9-1.171-1q-2.246-.277-4.5-.534c-.992-.112-1.283-.423-1.284-1.438q0-4.775,0-9.55ZM15.48,6.283c0-1.658-.012-3.232,0-4.806A1.309,1.309,0,0,0,14.165.02c-1.949-.029-3.9-.023-5.847,0A1.242,1.242,0,0,0,7,1.127c-.049,1.707-.017,3.416-.017,5.156Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14830",
    "data-name": "Path 14830",
    d: "M7.01,67.432h8.512c0,1.4-.041,2.763.014,4.124a17.667,17.667,0,0,0,.333,3.035,9.848,9.848,0,0,0,3.071,5.275,11.4,11.4,0,0,1,3.8,8.928q-.036,20.178-.01,40.357c0,2.092-.881,2.992-2.944,2.993q-8.434,0-16.868,0a4.55,4.55,0,0,1-1.239-.128,2.348,2.348,0,0,1-1.672-2.381q0-20.91.013-41.821A10.079,10.079,0,0,1,3.3,80.29a11.282,11.282,0,0,0,3.72-8.956c-.038-1.274-.006-2.55-.006-3.9m11.264,41.649q0-5.365,0-10.729c0-1.436-.6-2.055-2.015-2.058q-4.946-.011-9.893,0c-1.384,0-2.007.627-2.008,2q0,10.729,0,21.458c0,1.378.628,2.008,1.992,2.009q4.912,0,9.823,0c1.556,0,2.1-.54,2.1-2.089q0-5.295,0-10.59",
    transform: "translate(0 -58.028)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14831",
    "data-name": "Path 14831",
    d: "M213.368,248.2v2.482q0,4.775,0,9.55c0,1.015.292,1.326,1.284,1.438q2.249.255,4.5.534c.817.1,1.193.431,1.171,1-.023.6-.446.9-1.318.9q-4.531.007-9.062,0c-1.65,0-3.3,0-4.949,0-.839,0-1.237-.286-1.273-.87s.324-.914,1.147-1.03c1.609-.225,3.219-.455,4.832-.651.668-.082,1.016-.4,1.017-1.076q0-6.03,0-12.059a1.777,1.777,0,0,0-.045-.277c-.714-.155-1.424-.271-2.111-.465a11.9,11.9,0,0,1-8.743-12.331c.2-2.629.772-5.23,1.2-7.84.275-1.695.576-3.386.886-5.075a1.736,1.736,0,0,1,1.963-1.645q8.226-.01,16.451,0a1.814,1.814,0,0,1,1.956,1.525c.712,4.046,1.559,8.077,2.05,12.15.811,6.722-3.736,12.5-10.511,13.668-.114.02-.228.037-.436.07m7.842-15.945-1.5-8.619H204.467l-1.572,9.2c1.09.1,2.114.274,3.139.278a11.157,11.157,0,0,0,4.629-1.393,10.017,10.017,0,0,1,6.644-.84,40.163,40.163,0,0,1,3.9,1.369",
    transform: "translate(-171.918 -189.997)",
    fill: "#8e2828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14832",
    "data-name": "Path 14832",
    d: "M58.523,6.283H50.029c0-1.741-.032-3.45.017-5.156A1.242,1.242,0,0,1,51.36.018c1.949-.021,3.9-.027,5.847,0a1.309,1.309,0,0,1,1.32,1.457c-.017,1.574,0,3.148,0,4.806",
    transform: "translate(-43.043 0)",
    fill: "#8e2828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14833",
    "data-name": "Path 14833",
    d: "M45.147,287.15q0,5.295,0,10.59c0,1.549-.545,2.088-2.1,2.089q-4.912,0-9.823,0c-1.363,0-1.991-.631-1.992-2.009q0-10.729,0-21.458c0-1.371.624-1.995,2.008-2q4.946-.011,9.893,0c1.416,0,2.014.622,2.015,2.058q0,5.365,0,10.729",
    transform: "translate(-26.873 -236.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14834",
    "data-name": "Path 14834",
    d: "M240.446,249.874a40.16,40.16,0,0,0-3.9-1.369,10.017,10.017,0,0,0-6.644.84,11.157,11.157,0,0,1-4.629,1.393c-1.025,0-2.049-.175-3.139-.278l1.572-9.2h15.246l1.5,8.619",
    transform: "translate(-191.154 -207.611)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlcohol);
export default __webpack_public_path__ + "static/media/Alcohol.2aa1e43c3b665161d4102a027598e9d7.svg";
export { ForwardRef as ReactComponent };